module.exports = __webpack_public_path__ + "af35ec0e9c9c00b8c6f8afab514a70ea.svg";